import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import PaginationButton from "./PaginationButton";

const PaginationButtonPrevious = ({ onClick, disabled = false, fontSize = undefined, hidden = false }) => {
    return <PaginationButton hidden={hidden} icon={<FaArrowLeft fontSize={fontSize} />} onClick={onClick} disabled={disabled} />
}

export default PaginationButtonPrevious;
